import { Button } from '@talentmesh/ui/components/button';
import { cn } from '@talentmesh/ui/lib/utils';
import { FilterIcon } from 'lucide-react';
import { useCandidatesOverviewContext } from '../../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';

function ToolbarFilterButton() {
    const { openFilter, toggleOpenFilter } = useCandidatesOverviewContext();

    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={toggleOpenFilter}
            data-cy="ToolbarFilterButton"
            aria-expanded={openFilter}
            aria-pressed={openFilter}
            type="button"
            className={cn(openFilter ? 'bg-accent text-primary' : 'text-muted-foreground')}
        >
            <FilterIcon />
        </Button>
    );
}

export default ToolbarFilterButton;
